import { useEffect, useState } from "react";
import "./Popup.css";

const EMPTY = {
  equipamento: "",
  equipamento_tipo: "",
  equipamento_km_inicial: "",
  equipamento_km_final: "",
  gerencia_nome: "",
  coordenador_nome: "",
  subdivisao_id: "",
  subdivisao_nome: "",
  supervisor_id: "",
  supervisor_nome: "",
  operacao: "",
  entre_estacoes: "",
  no: "",
  sb: "",
};

const U = (v) => (typeof v === "string" ? v.toUpperCase() : v ?? "");

export default function EditarEquipamento({ open, onClose, onSalvar, registro }) {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open || !registro) return;
    setForm({
      equipamento: registro.equipamento ?? "",
      equipamento_tipo: registro.equipamento_tipo ?? "",
      equipamento_km_inicial: registro.equipamento_km_inicial ?? "",
      equipamento_km_final: registro.equipamento_km_final ?? "",
      gerencia_nome: registro.gerencia_nome ?? "",
      coordenador_nome: registro.coordenador_nome ?? "",
      subdivisao_id: registro.subdivisao_id ?? "",
      subdivisao_nome: registro.subdivisao_nome ?? "",
      supervisor_id: registro.supervisor_id ?? "",
      supervisor_nome: registro.supervisor_nome ?? "",
      operacao: registro.operacao ?? "",
      entre_estacoes: registro.entre_estacoes ?? "",
      no: registro.no ?? "",
      sb: registro.sb ?? "",
    });

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open, registro]);

  if (!open || !registro) return null;

  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  function normalize(payload) {
    return {
      ...payload,
      equipamento: U(payload.equipamento),
      equipamento_tipo: U(payload.equipamento_tipo),
      equipamento_km_inicial: String(payload.equipamento_km_inicial || "").trim(),
      equipamento_km_final: String(payload.equipamento_km_final || "").trim(),
      gerencia_nome: U(payload.gerencia_nome),
      coordenador_nome: U(payload.coordenador_nome),
      subdivisao_id: U(payload.subdivisao_id),
      subdivisao_nome: U(payload.subdivisao_nome),
      supervisor_id: U(payload.supervisor_id),
      supervisor_nome: U(payload.supervisor_nome),
      operacao: U(payload.operacao),
      entre_estacoes: U(payload.entre_estacoes),
      no: U(payload.no),
      sb: U(payload.sb),
    };
  }

  async function handleSalvar() {
    setBusy(true);
    setErr("");
    try {
      await onSalvar?.(normalize(form));
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar");
    } finally {
      setBusy(false);
    }
  }

  const fields = [
    ["equipamento", "Equipamento"],
    ["equipamento_tipo", "Tipo"],
    ["equipamento_km_inicial", "KM inicial (ex.: 10+250 ou 10.250)"],
    ["equipamento_km_final", "KM final (ex.: 10+800 ou 10.800)"],
    ["gerencia_nome", "Gerência"],
    ["coordenador_nome", "Coordenador"],
    ["subdivisao_id", "Subdivisão ID"],
    ["subdivisao_nome", "Subdivisão nome"],
    ["supervisor_id", "Supervisor ID"],
    ["supervisor_nome", "Supervisor nome"],
    ["operacao", "Operação"],
    ["entre_estacoes", "Entre estações"],
    ["no", "Nº"],
    ["sb", "SB"],
  ];

  return (
    <div className="eqpm-modal-overlay" onClick={onClose}>
      <div className="eqpm-modal-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="eqpm-modal-head">
          <h2>Editar equipamento #{registro.id}</h2>
          <button className="eqpm-modal-close" type="button" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </div>

        <div className="eqpm-modal-body eqpm-modal-grid">
          {fields.map(([k, label]) => (
            <label key={k} className="eqpm-field">
              <span>{label}</span>
              <input className="eqpm-input" value={form[k] ?? ""} onChange={set(k)} />
            </label>
          ))}

          {err ? <div className="eqpm-modal-err">{err}</div> : null}
        </div>

        <div className="eqpm-modal-foot">
          <button className="eqpm-btn" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="eqpm-btn eqpm-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alterações"}
          </button>
        </div>
      </div>
    </div>
  );
}
